module.exports = __webpack_public_path__ + "img/pet_bostie.557ef505.svg";